<template>
    <div class="wrapper">
        <section class="column left">
            <div class="buttonset">
                <button
                    class="button" 
                    v-for="preset in presets"
                    :key="preset.name"  
                    v-on:click="applyPreset(preset.name)">
                    {{preset.name}}
                </button>
            </div>

            <fieldset>
                <legend>Show</legend>

                <div class="field">
                    <label for="showRects">Rectangles</label>
                    <input id="showRects" type="checkbox" v-model="grid.showRects"/>
                </div>

                <div class="field">
                    <label for="showGuides">Guides</label>
                    <input id="showGuides" type="checkbox" v-model="grid.showGuides"/>
                </div>

                <div class="field">
                    <label for="showMargins">Margins</label>
                    <input id="showMargins" type="checkbox" v-model="grid.showMargins"/>
                </div>

                <div class="field">
                    <label for="showHcenter">H Center</label>
                    <input id="showHcenter" type="checkbox" v-model="grid.showHcenter"/>
                </div>

                <div class="field">
                    <label for="showVcenter">V Center</label>
                    <input id="showVcenter" type="checkbox" v-model="grid.showVcenter"/>
                </div>
            </fieldset>

            <br/>

            <fieldset>
                <legend>Dimensions 
                    <button class="extra" name="flip-dimensions" 
                        v-on:click="flipDimensions">
                        Flip
                    </button>
                </legend>

                <div class="field">
                    <label for="width">Width</label>
                    <input id="width" type="number" 
                        min="10" v-model.number="grid.width"/>

                    <span class="spacer">&nbsp;</span>

                    <label for="height">Height</label>
                    <input id="height" type="number" 
                        min="10" v-model.number="grid.height"/>
                    
                </div>
            </fieldset>

            <fieldset>
                <legend>Divisions</legend>
                <div class="field">
                    <label for="columns">Columns</label>
                    <input id="columns" type="number"
                        min="1" v-model.number="grid.columns"/>
                
                    <span class="spacer">&nbsp;</span>

                    <label for="rows">Rows</label>
                    <input id="rows" type="number" 
                        min="1" v-model.number="grid.rows"/>
                </div>
            </fieldset>

            <br/>

            <fieldset>
                <legend>Margins</legend>

                <div class="field">
                    <label for="marginTop">Top</label>
                    <input id="marginTop" type="number" 
                        min="0" v-model.number="grid.marginTop"/>

                    <span class="spacer">&nbsp;</span>

                    <label for="marginBottom">Bottom</label>
                    <input id="marginBottom" type="number" 
                        min="0" v-model.number="grid.marginBottom"/>
                </div>

                <div class="field">
                    <label for="marginLeft">Left</label>
                    <input id="marginLeft" type="number" 
                        min="0" v-model.number="grid.marginLeft"/>

                    <span class="spacer">&nbsp;</span>

                    <label for="marginRight">Right</label>
                    <input id="marginRight" type="number" 
                        min="0" v-model.number="grid.marginRight"/>
                </div>
            </fieldset>

            <fieldset>
                <legend>Gutters</legend>

                <div class="field">
                    <label for="hgutter">Horizontal</label>
                    <input id="hgutter" type="number" 
                        min="0" v-model.number="grid.hgutter"/>

                    <span class="spacer">&nbsp;</span>

                    <label for="vgutter">Vertical</label>
                    <input id="vgutter" type="number" 
                        min="0" v-model.number="grid.vgutter"/>
                </div>
            </fieldset>

            <fieldset>
                <legend>Colors</legend>

                <div class="field">
                    <label for="columnRectColor">Column</label>
                    <input id="columnRectColor" type="color" 
                        v-model="grid.columnColor" :disabled="!grid.showRects"/>

                    <span class="spacer">&nbsp;</span>

                    <label for="columnRectOpacity">Opacity</label>
                    <input id="columnRectOpacity" type="number" 
                        min="0.05" max="1" step="0.05"
                        v-model.number="grid.columnOpacity" :disabled="!grid.showRects"/>
                </div>

                <div class="field">
                    <label for="rowRectColor">Row</label>
                    <input id="rowRectColor" type="color" 
                        v-model="grid.rowColor" :disabled="!grid.showRects"/>

                    <span class="spacer">&nbsp;</span>

                    <label for="rowRectOpacity">Opacity</label>
                    <input id="rowRectColorOpacity" type="number" 
                        min="0.05" max="1" step="0.05"
                        v-model.number="grid.rowOpacity" :disabled="!grid.showRects"/>
                </div>

                <div class="field">
                    <label for="guidelineColor">Guideline</label>
                    <input id="guidelineColor" type="color" 
                        v-model="grid.guideColor" :disabled="!grid.showGuides"/>

                    <span class="spacer">&nbsp;</span>

                    <label for="guidelineOpacity">Opacity</label>
                    <input id="guidelineOpacity" type="number" 
                        min="0.05" max="1" step="0.05"
                        v-model.number="grid.guideOpacity" :disabled="!grid.showGuides"/>
                </div>

                <div class="field">
                    <label for="marginColor">Margin</label>
                    <input id="marginColor" type="color" 
                        v-model="grid.marginColor" :disabled="!grid.showMargins"/>

                    <span class="spacer">&nbsp;</span>

                    <label for="marginOpacity">Opacity</label>
                    <input id="marginOpacity" type="number" 
                        min="0.05" max="1" step="0.05"
                        v-model.number="grid.marginOpacity" :disabled="!grid.showMargins"/>
                </div>

                <div class="field">
                    <label for="centerlineColor">Center</label>
                    <input id="centerlineColor" type="color" 
                        v-model="grid.centreLineColor" :disabled="!grid.showHcenter && !grid.showHcenter"/>

                    <span class="spacer">&nbsp;</span>

                    <label for="centerlineOpacity">Opacity</label>
                    <input id="centerlineOpacity" type="number"
                        min="0.05" max="1" step="0.05" 
                        v-model.number="grid.centreLineOpacity" :disabled="!grid.showHcenter && !grid.showHcenter"/>
                </div>
            </fieldset>

            <div class="buttonset">
                <a class="button"
                    name="export_svg"
                    download="guide.svg"
                    :href="fileForExport">
                    Export SVG
                </a>
            </div>
        </section>

        <section 
            class="column right"
            id="svgwrapper" 
            v-bind:style="{ width: grid.width + 'px' , height: grid.height + 'px' }">
        </section>
    </div>
</template>

<script> 
import { Grid } from '@/modules/grid';
import { Guide } from '@/modules/guide';
import { Rect } from '@/modules/rect';
import { GenerateSVG } from '@/modules/SvgGenerator'

export default {
  name: 'SvgEditor',
  computed: {
        rects : function()  {
            var rects = [];
            let hSpace = (this.grid.width - (this.grid.marginLeft + this.grid.marginRight));
            let vSpace = (this.grid.height - (this.grid.marginTop + this.grid.marginBottom));

            // Cols + H gutters
            let totalHGutterSpace = ((this.grid.columns -1) * this.grid.hgutter);
            let colWidth = (hSpace - (totalHGutterSpace)) / this.grid.columns;

            // draw column, then vGutter
            let hPosition = this.grid.marginLeft;
            for (let c = 0; c < this.grid.columns; c++) {
                rects.push(new Rect(vSpace, colWidth, hPosition, this.grid.marginTop, this.grid.columnColor, this.grid.columnOpacity, `Column${c}`));
                hPosition += (colWidth + this.grid.hgutter);
            }

            // Rows + V Gutters
            let totalVGutterSpace = ((this.grid.rows -1) * this.grid.vgutter);
            let rowHeight = (vSpace - (totalVGutterSpace)) / this.grid.rows;
            
            // draw row, then hgutter
            let vPosition = this.grid.marginTop;
            for (let r = 0; r < this.grid.rows; r++) {
                rects.push(new Rect(rowHeight, hSpace, this.grid.marginLeft, vPosition, this.grid.rowColor, this.grid.rowOpacity, `Row${r}`));
                vPosition += (rowHeight + this.grid.vgutter);
            }

            return rects;
        },
        guides: function () {
            var guides = [];
            let hSpace = (this.grid.width - (this.grid.marginLeft + this.grid.marginRight));
            let vSpace = (this.grid.height - (this.grid.marginTop + this.grid.marginBottom));

             // Margins x 4 (0 + margin & width/width - margin)
            guides.push(new Guide((this.grid.marginLeft), true, this.grid.marginColor, this.grid.marginOpacity, "Left_Margin"));
            guides.push(new Guide((this.grid.width - this.grid.marginRight), true, this.grid.marginColor, this.grid.marginOpacity, "Right_Margin"));
            guides.push(new Guide((this.grid.marginTop), false, this.grid.marginColor, this.grid.marginOpacity, "Top_Margin"));
            guides.push(new Guide((this.grid.height - this.grid.marginBottom), false, this.grid.marginColor, this.grid.marginOpacity, "Bottom_Margin"));

            // Cols + h gutters
            let totalHGutterSpace = ((this.grid.columns -1) * this.grid.hgutter);
            let colWidth = (hSpace - (totalHGutterSpace)) / this.grid.columns;
            let hPosition = this.grid.marginLeft;
            for (let c = 0; c < this.grid.columns; c++) {
                if (c > 0) {
                    hPosition += this.grid.hgutter;
                    guides.push(new Guide(hPosition, true, this.grid.guideColor, this.grid.guideOpacity));
                }

                hPosition += colWidth;
                guides.push(new Guide(hPosition, true, this.grid.guideColor, this.grid.guideOpacity));
            }

            // Rows + v gutters
            let totalVGutterSpace = ((this.grid.rows -1) * this.grid.vgutter);
            let rowHeight = (vSpace - (totalVGutterSpace)) / this.grid.rows;
            let vPosition = this.grid.marginTop;
            for (let r = 0; r < this.grid.rows; r++) {
                if (r > 0) {
                    vPosition += this.grid.vgutter;
                    guides.push(new Guide(vPosition, false, this.grid.guideColor, this.grid.guideOpacity));
                }

                vPosition += rowHeight;
                guides.push(new Guide(vPosition, false, this.grid.guideColor, this.grid.guideOpacity));
            }

            return guides;
        },
        margins : function() {
            var margins = [];

            // PG: TODO - steal from guides function above

            return margins;
        },
        centerLines : function() {
            var centerLines = [];

            if (this.grid.showHcenter) {
                centerLines.push(new Guide((this.grid.height / 2), false, this.grid.centerLineColor, this.grid.centreLineOpacity, "Horizontal Center"))
            }

            if (this.grid.showVcenter) {
                centerLines.push(new Guide((this.grid.width / 2), true, this.grid.centerLineColor, this.grid.centreLineOpacity, "Vertical Center"));
            }

            return centerLines;
        }
  },
  methods: {
    applyPreset : function(presetName) {
        let preset = this.presets.filter(x => x.name == presetName)[0];
        if (preset) {
            this.grid.width = preset.width;
            this.grid.height = preset.height;
        }
    },
    setDimensions : function(height, width) {
        this.grid.width = width;
        this.grid.height = height;
    },
    flipDimensions : function() {
        this.setDimensions(this.grid.width, this.grid.height);
    },
    prepExport : function() {
        let svgEl = GenerateSVG(this.grid, this.rects, this.guides, this.margins, this.centerLines);
        if (svgEl) {
            this.redrawSvg(svgEl);
            svgEl = new XMLSerializer().serializeToString(svgEl);
            let svgXML = `<?xml version="1.0" encoding="UTF-8" standalone="no"?>${svgEl}`;
            this.fileForExport = `data:text/xml;charset=utf-8,${encodeURIComponent(svgXML)}`;
        }
    },
    redrawSvg : function(svgEl) {
        let svgWrapperEl = document.getElementById('svgwrapper');
        if (svgWrapperEl) {
            while (svgWrapperEl.firstChild != null) {
                svgWrapperEl.removeChild(svgWrapperEl.firstChild);
            }

            svgWrapperEl.appendChild(svgEl);
        }
    }
  },
  data: function() {
      return {
          grid: new Grid(),
          presets: [
              new Grid(1052.36290, 793.70079, 'ISO A4'),
              new Grid(793.70079, 559.37008, 'ISO A5'),
              new Grid(524.40945, 372.04724, 'ISO A6'),
              new Grid(630, 450, '5x7')
          ],
          fileForExport: ''
      }
  },
  mounted : function() {
    this.prepExport();
  },
  updated: function () {
    this.prepExport();
  }
}
</script>

<style scoped lang="less">
.wrapper {
    display: flex;
    height: 100%;
    width: 100%;
    flex-direction: row;

    .column.left {
        width: 300px;
        border: 1px grey solid;
        height: 640px;

        fieldset {
            border: 0;
            display: inline-block;
            width: 100%;

            legend {
                text-align: left;
                padding: 0px;
                font-weight: bold;
            }

            .field {
                padding: 0px 0px 0px 10px;
                text-align: left;

                label {
                    width: 80px;
                    display: inline-block;
                }

                input {
                    width:40px;
                    display: inline-block;
                    text-align: left;
                }

                .spacer {
                    width: 10px;
                    max-width: 10px;
                }

                .extra {
                    width: 50px;
                    display: inline-block;
                }
            }
        }
    }

    .column.right {
        width: 100%;
    }
    
    #svgwrapper {
        margin: 20px auto 0 auto;
        border: 1px black solid;
    }

    .buttonset {
        text-align:center;
        margin: 0 auto;

        .button,
        .button:visited,
        .button:link {
            background-color: #dddddd;
            border: 1px grey solid;
            border-radius: 3px;
            color: #2c3e50;
            display: inline-block;
            margin: 10px 5px;
            padding: 3px 5px;
            text-decoration: none;

            &:active,
            &:hover,
            &:focus {
                background-color: #ffffff;
            }
        }
    }
}
</style>